export const menuItemImageLoader = ({ src }) => {
  const uploadIndex = src.indexOf('upload/');
  if (uploadIndex === -1) return src;

  const urlUpToUploadSlug = src.substring(0, uploadIndex + 7);
  const filename = src.substring(uploadIndex + 7);

  return `${urlUpToUploadSlug}c_fit,h_338,q_90,r_0,w_600/${filename}`;
};
